(function ($) {
  'use strict';

  Drupal.behaviors.overlayPasswordProtectionV1 = {
    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;

      var $template = $('.js-overlay-password-protection', context);
      var $overlay = $('.js-overlay-password-protection-container', $template);
      var $overlayForm = $('.js-overlay-password-protection-form', $overlay);
      var $overlayFormSubmit = $('.js-overlay-password-protection-submit', $overlayForm);
      var $overlayError = $('.js-overlay-password-protection-error', $overlayForm);
      var $emailField = $("input[name='PASSWORD']", $overlayForm);
      var cookieName = $overlay.data('cname');

      if (generic.cookie(cookieName)) {
        $template.addClass('hidden');

        return;
      }
      $overlay.removeClass('hidden');
      $overlayFormSubmit.click(function (e) {
        e.preventDefault();
        if ($emailField.val() === $emailField.data('expectedPassword')) {
          $template.addClass('hidden');
          generic.cookie(cookieName, 1);
        } else {
          $overlayError.removeClass('hidden');
        }
      });
    },
    attached: false
  };
})(jQuery);
